/*
 * Copyright (c) 2024, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import React from "react";
import { TextField } from "@material-ui/core";
import { useIntl } from "react-intl";

interface PayloadEditorProps {
  fileContent: string;
  setFileContent: (value: string) => void;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function PayloadEditor({
  fileContent,
  setFileContent,
}: PayloadEditorProps) {
  const intl = useIntl();
  return (
    <TextField
      data-testid="input-message-box"
      id="outlined-full-width"
      placeholder= 
      {intl.formatMessage({
        id: "components.api.ApiTryout.WebSocketViewer.PayloadEditor.textField.placeholder",
        defaultMessage: `Enter your message here.`,
      })}
      fullWidth
      margin="none"
      InputLabelProps={{
        disableAnimation: true,
      }}
      InputProps={{
        disableUnderline: true,
        style: {
          padding: '0 10px'
        }
      }}
      variant="standard"
      multiline
      rows={11}
      name="newMessage"
      onChange={(event) => setFileContent(event.target.value)}
      value={fileContent}
    />
  );
}
